/**
 * Shared document head helper for TanStack Router route head.
 * Replaces the former SEO component / react-helmet-async usage.
 */

const DEFAULT_SITE_TITLE = 'Turfmaster';
const DEFAULT_DESCRIPTION = 'Turfmaster – Pferderennspiel';
const SITE_AUTHOR = 'AZA Spiele e.K.';

export function buildDefaultMeta(description: string, pageTitle: string = DEFAULT_SITE_TITLE) {
  return [
    { name: 'robots', content: 'noindex, nofollow' as const },
    { name: 'description', content: description },
    { property: 'og:title', content: pageTitle },
    { property: 'og:description', content: description },
    { property: 'og:type', content: 'website' as const },
    { name: 'twitter:card', content: 'summary' as const },
    { name: 'twitter:creator', content: SITE_AUTHOR },
    { name: 'twitter:title', content: pageTitle },
    { name: 'twitter:description', content: description },
  ];
}

export interface RouteHeadOptions {
  title?: string;
  description?: string;
}

/**
 * Returns the head object for a route. Use in route option: head: () => getRouteHead({ title: '...' }).
 * Page title is rendered as "Title | Turfmaster" when title is provided.
 */
export function getRouteHead(options: RouteHeadOptions = {}) {
  const { title, description = DEFAULT_DESCRIPTION } = options;
  const fullTitle = title ? `${title} | ${DEFAULT_SITE_TITLE}` : DEFAULT_SITE_TITLE;
  return {
    title: fullTitle,
    meta: buildDefaultMeta(description, fullTitle),
  };
}

export { DEFAULT_DESCRIPTION, DEFAULT_SITE_TITLE, SITE_AUTHOR };
